import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";
export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']

export const FogTableConfig = {
  tableInfo: {
    type: 'dataTable',
    title: {
      display: true,
      text: '',
      align: 'center',
      order: 'order-md-2'
    }
  },
  css: {
    tableClass: 'table table-striped table-bordered m-0',
    theadClass: '',
    tbodyClass: ''
  },
  // sortOptions: {
  //   sortIndex: 0,
  //   sortType: 'desc'
  // },
  searchFilter: {
    display: true
  },
  breadcrumbCons: {
    show: true,
    queryparams: []
  },
  printButton: {
    display: true,
    text: 'Print',
    align: 'right',
    order: 'order-md-2',
    title: 'Fog Count'
  },
  paginatorOptions: {
    visible: false
  },
  tableHeaderFixerInfo: {
    headerFix: true,
    colFix: true,
    rowFix: false,
    noOfCol: 1,
    height: '500px'
  },
  totalRow: {
    position: 'bottom',
    name: 'Total',
    jsonKey: '-1',
    colspan: 1,
    class: 'fixed-row'
  },
  indexCons: {
    show: false
  },

  downloadButton: {

    display: true,
    text: 'Download',
    align: 'right', // where to align the element within div i.e left, center or right
    order: 'order-md-3',// Order of the element from left. defined in DataTableModule.toolBarElementOrder
  },
  downloadOptions: [
    {
      downloadType: 'xlsx',
      downloadFileName: 'Fog Data',
      downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
      metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    },
    //     {
    //         downloadType: 'pdf',
    //         downloadFileName: 'Unified Farmer Database',
    //         downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
    //         metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    //     },
    //     {
    //         downloadType: 'csv',
    //         downloadFileName: 'Unified Farmer Database',
    //         downloadAll: true, // pass false if only current page data is to be downloaded & to make sure data comes in sorted manner
    //         metaData: false // pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
    //     }
  ],

  columns: []
};

export const FogColumnConfig = [
  {
    name: 'State',
    jsonKey: { path: 'locName##locUUID' },
    dataType: 'LOCATION'
  },
  // {
  //   name: 'Shallow',
  //   jsonKey: { path: 'fogData.Shallow' },
  //   dataType: 'NUMBER'
  // },
  // {
  //   name: 'Moderate',
  //   jsonKey: { path: 'fogData.Moderate' },
  //   dataType: 'NUMBER'
  // },
  // {
  //   name: 'Dense',
  //   jsonKey: { path: 'fogData.Dense' },
  //   dataType: 'NUMBER'
  // },
  // {
  //   name: 'Very Dense',
  //   jsonKey: { path: 'fogData.Very_Dense' },
  //   dataType: 'NUMBER'
  // },
  // {
  //   name: 'Normal',
  //   jsonKey: { path: 'fogData.Normal' },
  //   dataType: 'NUMBER'
  // }
];

export const ADMIN_LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
// export const FOG_LAYER_LIST: any = {
//   [AgricultureMapConstants.LOCATIONS.INDIA]: {
//     'District Boundary': {
//       source: 'INDIA',
//       displayName: 'District',
//       name: 'District Boundary',
//       visible: true,
//       // hasLegend: true,
//       view: AgricultureMapConstants.VIEWS.ADMIN,
//       dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//       layerptions_show_on_selector: false,
//       layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
//       layer_name: 'District Boundary',
//       layeroptions_pane: 'district',
//       // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
//       layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
//       layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
//       group: 'boundaries',
//       group_type: 'radio-deselect',
//       layerServiceType: LAYER_TYPES.VECTOR_LAYER,
//       type: LAYER_TYPES.VECTOR_LAYER,
//       cql_filter_value: null,
//       cql_filter: null,
//       layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//       environment_server_url: 'COMMON_GEOSERVER_URL',
//       // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
//       crs: 'EPSG4326',
//       hasLables: true,
//       applycql_filter: true,
//       legendName: 'FOG_LEGEND',
//       layeroptions_protocol: 'WFS'
//     },
//     'Block Boundary': {
//       source: 'INDIA',
//       displayName: 'Block',
//       name: 'Block Boundary',
//       visible: true,
//       view: AgricultureMapConstants.VIEWS.ADMIN,
//       dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//       layerptions_show_on_selector: false,
//       layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
//       layer_name: 'Block Boundary',
//       layeroptions_pane: 'state',
//       // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
//       layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
//       layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
//       group: 'boundaries',
//       group_type: 'radio-deselect',
//       layerServiceType: LAYER_TYPES.VECTOR_LAYER,
//       type: LAYER_TYPES.VECTOR_LAYER,
//       cql_filter_value: null,
//       cql_filter: null,
//       layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//       environment_server_url: 'COMMON_GEOSERVER_URL',
//       // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
//       crs: 'EPSG4326',
//       hasLables: true,
//       applycql_filter: true,
//       legendName: 'FOG_LEGEND',
//       layeroptions_protocol: 'WFS'
//     },
//   }
// }

export const FOG_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    'India Boundary': {
      source: 'INDIA',
      displayName: 'India',
      name: 'India Boundary',
      visible: true,
      // hasLegend: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'odisha:india_boundary',
      layer_name: 'India Boundary',
      layeroptions_pane: 'base',
      // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      // legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary',
      visible: true,
      // hasLegend: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundaries': {
      source: 'INDIA',
      displayName: 'District Boundaries',
      name: 'District Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundaries',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      onEachFeature: 'handleAdminPolygons',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_protocol: 'WFS'
    },
    'District Boundary': {
      source: 'INDIA',
      displayName: 'District',
      name: 'District Boundary',
      visible: true,
      // hasLegend: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary',
      layeroptions_pane: 'district',
      // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Block Boundary': {
      source: 'INDIA',
      displayName: 'Block',
      name: 'Block Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary',
      layeroptions_pane: 'state',
      // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary Labels': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'District Boundary Labels': {
      source: 'INDIA',
      displayName: 'District Boundary Labels',
      name: 'District Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'state_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'Block Boundary Labels': {
      source: 'INDIA',
      displayName: 'Block Boundary Labels',
      name: 'Block Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'dist_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'Airport Boundary': {
      source: 'INDIA',
      displayName: 'Airport Boundary',
      name: 'Airport Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_Airport_Points',
      layer_name: 'Airport Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      pointToLayer: 'handleAirportPointLayer',
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
      // crs: 'EPSG4326',
      // hasLables: true,
      // applycql_filter: true,
      // legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS',
      restrictFitBounds: true
    },
    'Railway Boundary': {
      source: 'INDIA',
      displayName: 'Railway Boundary',
      name: 'Railway Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_Railway_lines',
      layer_name: 'Railway Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Highway Boundary': {
      source: 'INDIA',
      displayName: 'Highway Boundary',
      name: 'Highway Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:India_highway',
      layer_name: 'Highway Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'FOG_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    // 'Railway Boundary': {
    //     source: 'INDIA',
    //     displayName: 'Railway Boundary',
    //     name: 'Railway Boundary',
    //     visible: true,
    //     view: AgricultureMapConstants.VIEWS.ADMIN,
    //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
    //     layerptions_show_on_selector: false,
    //     layeroptions_name: 'HEATWAVE:India_Railways_lines',
    //     layer_name: 'Railway Boundary',
    //     layeroptions_pane: 'depth',
    //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MIN - 3,
    //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.BLOCK].MAX,
    //     group: 'Labels',
    //     group_type: 'radio-deselect',
    //     layerServiceType: LAYER_TYPES.WMS_LAYER,
    //     type: LAYER_TYPES.WMS_LAYER,
    //     // cql_filter_value: 'Dist_UUID',
    //     cql_filter: null,
    //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
    //     environment_server_url: 'COMMON_GEOSERVER_URL',
    //     // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
    //     crs: 'EPSG4326',
    // }
  }
}

export const FOG_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    FOG_LEGEND: {
      // "Units": "Heatwave ",
      "colorValues": [
        {
          backgroundColor: '#595856',
          text: 'Shallow Fog',
          textColor: '#000000'
        },
        {
          backgroundColor: '#868580',
          text: 'Moderate Fog',
          textColor: '#000000'
        },
        {
          backgroundColor: '#EDECEB',
          text: 'Dense Fog',
          textColor: '#000000'
        },
        {
          backgroundColor: '#F8F8F6',
          text: 'Very Dense Fog',
          textColor: '#000000'
        },
        // {
        //   backgroundColor: '#fff',
        //   text: 'Normal',
        //   textColor: '#000'
        // }
      ]
    }
  }
}
export const FogMapConstants: any = {
  HeatMapOptions: {
    type: 'Time',
    time: '24',
    clip: true,
    view: 'Admin',
    serviceType: 'HeatMap'
  }
}

export const FOGALERT_VIEWTYPE: any = {
  'Airport Boundary': 'Airport',
  'Railway Boundary': 'Railway',
  'Highway Boundary': 'Highway'
}

export function getAdvisoryHTML(sector, category) {

  const advisories: any = {
    Airport: {
      'Very Dense': [
        'Extremely low visibility',
        'Severe impact on flight schedules expected',
        'High likelihood of delays and diversions',
        'Passengers advised to check flight status'
      ],
      Dense: [
        'Significantly reduced visibility',
        'Delays possible during peak hours',
        'Passengers advised to check flight status'
      ],
      Moderate: [
        'Reduced visibility conditions',
        'Minor delays possible',
        'Normal operation with caution'
      ],
      Shallow: [
        'Localized fog patches near airport areas',
        'Minimized impact on operations expected'
      ],
      Normal: [
        'Normal visibility conditions',
        'Standard operations in effect'
      ]
    },

    Railway: {
      'Very Dense': [
        'Train speeds severely restricted',
        'Automatic fog signal devices activated',
        'Signal sighting distance critically low',
        'High risk of SPAD',
        'Crew alertness protocols enforced',
        'Passengers advised to check train status'
      ],
      Dense: [
        'Speed reduction (30–50%)',
        'Enhanced whistle and vigilance',
        'Use of signal repeaters if available',
        'Passengers advised to check train status'
      ],
      Moderate: [
        'Moderate speed reduction',
        'Extra caution at junctions and crossings'
      ],
      Shallow: [
        'Localized fog patches',
        'Normal operation with increased caution'
      ],
      Normal: [
        'Normal rail operations',
        'Standard speed limits apply'
      ]
    },

    Highway: {
      'Very Dense': [
        'Visibility near zero',
        'Very high accident risk',
        'Significant speed reduction advised',
        'Avoid travel if possible'
      ],
      Dense: [
        'Poor visibility conditions',
        'Speed reduction advised (30–40 km/h)',
        'Headlights and fog lamps recommended',
        'Maintain safe following distance'
      ],
      Moderate: [
        'Reduced visibility',
        'Caution advised',
        'Overtaking discouraged'
      ],
      Shallow: [
        'Patchy fog in low-lying stretches',
        'Normal traffic with caution'
      ],
      Normal: [
        'Normal road conditions',
        'Standard speed limits apply'
      ]
    }
  };

  const sectorAdvisory = advisories[sector];
  const messages = sectorAdvisory && sectorAdvisory[category]
    ? sectorAdvisory[category]
    : [];

  if (!messages.length) {
    return '';
  }

  let html = `
      <div class="advisory-title">
        <i class="fa fa-exclamation-triangle text-warning"></i>
        <span class="title">Advisory</span>
        </div>
      <ul class="advisory-list">
  `;

  messages.forEach((msg: string) => {
    html += `<li>${msg}</li>`;
  });

  html += `
      </ul>
    </div>
  `;

  return html;
}

export const FOG_CATEGORY_CONFIG: any = {
  'Very Dense': {
    label: 'Very Dense Fog',
    dotClass: 'fog-dot-very-dense',
    alertText: 'Red',
    alertClass: 'text-danger',
    headerStyle: { 'background': '#7a0000' },
  },
  Dense: {
    label: 'Dense Fog',
    dotClass: 'fog-dot-dense',
    alertText: 'Orange',
    alertClass: 'text-orange',
    headerStyle: { 'background': '#ff9800' }

  },
  Moderate: {
    label: 'Moderate Fog',
    dotClass: 'fog-dot-moderate',
    alertText: 'Yellow',
    alertClass: 'text-warning',
    headerStyle: { 'background': '#ffeb3b' }

  },
  Shallow: {
    label: 'Shallow Fog',
    dotClass: 'fog-dot-shallow',
    alertText: 'Blue',
    alertClass: 'text-info',
    headerStyle: { 'background': '#9ad0ec' }
  },
  Normal: {
    label: 'Normal',
    dotClass: 'fog-dot-normal',
    alertText: 'Green',
    alertClass: 'text-success',
    headerStyle: { 'background': '#2e7d32' }
  }
};

export const FOGALERT_API_MAPPING: any = {
  Railway: 'fog/getVisibilityData',
  Highway: 'fog/getVisibilityData',
  Airport: 'nowcast/getAirPortFogData',
  Aviation_Count: 'nowcast/getAirportFogCategoryCount'
}

export const ALERT_COLOR_MAPPING: any = {
  Normal: '#228b22',
  Shallow: '#87ceeb',
  Moderate: '#ffd700',
  Dense: '#ff8c00',
  'Very Dense': '#8b0000'
}

export const SECTOR_ICON_CLASS: any = {
  Railway: 'fa fa-train text-light mr-2',
  Highway: 'fa fa-road text-light mr-2',
  Airport: 'fa fa-plane text-light mr-2'
}

export const FORMAT_VS_SOURCEMAPPING: any = {
  DAILY: {
    'ecmwf_1hr': 'ecmwf_1hr',
    'ecmwf_1hr_fog_visibility': 'ecmwf_1hr_fog_visibility'
  },
  HOURLY: {
    'ecmwf_1hr': 'ecmwf_1hr_hourly',
    'ecmwf_1hr_fog_visibility': 'ecmwf_1hr_fog_visibility_hourly'
  }
}


